// src/utils/languageStore.js
let currentLanguage = localStorage.getItem('lang') || 'en';
const subscribers = new Set();

export const getCurrentLanguage = () => currentLanguage;

export const setCurrentLanguage = (lang) => {
  currentLanguage = lang;
  localStorage.setItem('lang', lang);
  // Notify all subscribers of the change
  subscribers.forEach((callback) => callback(lang));
};

export const subscribeToLanguageChange = (callback) => {
  subscribers.add(callback);
  // Return an unsubscribe function
  return () => subscribers.delete(callback);
};
